import React, { Component } from 'react';
import { headingStyles, fontFamily } from '../../theme/typography';
interface HeadingProps {
  level: 'display' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}
/**
 * Reusable Heading component that enforces consistent typography
 *
 * @param level - The visual style level (display, h1, h2, etc.)
 * @param as - The actual HTML element to render (defaults to match level)
 * @param className - Additional CSS classes
 * @param style - Additional inline styles
 *
 * @example
 * <Heading level="h1">Main Section Title</Heading>
 * <Heading level="h2" as="h1">Subsection Title</Heading>
 */
export function Heading({
  level,
  children,
  className = '',
  style = {},
  as
}: HeadingProps) {
  const Component = as || (level === 'display' ? 'h1' : level);
  const baseStyles = headingStyles[level];
  // Use display font for display level, heading font for others
  const font = level === 'display' ? fontFamily.display : fontFamily.heading;
  return <Component className={`${baseStyles} ${className}`} style={{
    fontFamily: font,
    ...style
  }} data-id="element-2192">
      {children}
    </Component>;
}